import script from "./UserRenewalCode.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRenewalCode.vue?vue&type=script&setup=true&lang=js"

import "./UserRenewalCode.vue?vue&type=style&index=0&id=ee422b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee422b9c"]])

export default __exports__